const SIZES = { sm: 16, md: 22, lg: 32 } as const;

interface Props {
  size?: keyof typeof SIZES;
  /** Announced to assistive tech; omit when a visible label sits beside it. */
  label?: string;
  className?: string;
}

export function ActivityIndicator({ size = 'md', label, className = '' }: Props) {
  const px = SIZES[size];
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={`activity ${className}`}
      style={{ width: px, height: px }}
    >
      {Array.from({ length: 8 }, (_, i) => (
        <span key={i} className="activity-spoke" style={{ ['--i' as string]: i }} />
      ))}
    </span>
  );
}
